import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject, Observable, of, Subject, Subscription } from 'rxjs';
import { InsuranceService } from '../_services/insurance.services';
import { ClaimsService } from '../_services/claims.services';
import { ListClaimsService } from '../_services/listclaims.services';
import { DocumentService } from '../_services/document.services';
import { InterestService } from '../_services/interest.services';
import { HelperServices } from '../_services/helper.services';
import { exhaustMap } from 'rxjs/operators';
import { Policy } from '../_models/policy.model';
import { Document } from '../_models/document.model';
import { Interest } from '../_models/interest.model';
import { UserModel } from '../../modules/auth/_models/user.model';
import { Ramo, SubRamo, Mes, Anyo, Endoso } from '../_models/general.model';
import { AuthService } from '../../modules/auth/_services/auth.service';
import { LayoutService } from '../../_metronic/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal, ModalDismissReasons, NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer } from '@angular/platform-browser';
import { Claim, ClaimsDocuments } from '../_models/claim.model';
import { NgxMaskModule, IConfig } from 'ngx-mask'
import _, { map } from 'underscore';
import * as _moment from 'moment';
import JsFileDownloader from 'js-file-downloader';

declare var require: any
const FileSaver = require('file-saver');

declare var download: any;

import {
    GroupingState,
    PaginatorState,
    SortState,
    ICreateAction,
    IEditAction,
    IDeleteAction,
    IDeleteSelectedAction,
    IFetchSelectedAction,
    IUpdateStatusForSelectedAction,
    ISortView,
    IFilterView,
    IGroupingView,
    ISearchView,
} from '../../_metronic/shared/crud-table';

@Component({
    selector: 'app-list-claims',
    templateUrl: './list-claims.component.html',
    styleUrls: ['./list-claims.component.scss']
})

export class ListClaimsComponent implements
OnInit, 
OnDestroy {
    loadingModalConfig: NgbModalOptions = {
        backdrop : 'static',
        keyboard : false
    };
    loadingModal: boolean = false;
    paginator: PaginatorState;
    sorting: SortState;
    grouping: GroupingState;
    isLoading: boolean;
    templateView: number = 1;
    idPoliza: number = 0;
    idDocument: number = 0;
    idEntity: number = 0;
    insuredFilter: number = 0;
    policy_selected: Policy;
    claim_selected: Claim;
    document_selected: Document;
    documents_policy: Document[];
    interest_selected: Interest;
    showComapnyName: boolean = false;
    extrasUserDropdownStyle: 'light' | 'dark' = 'light';
    user$: Observable<UserModel>;
    _user: UserModel;
    hasError: boolean;
    IdReclamo: number = 1;
    ramos: any;
    subramos: any;
    anyos: any;
    meses: any;
    endosos: any;
    companies: any;
    pais:any;
    estado:any;
    ciudad:any;
    codigopostal:any;
    parentesco:any;
    tipointeres:any;
    causareclamo:any;
    sino:any;
    tiposEndosos;
    filterPolicyForm: FormGroup;
    interestForm: FormGroup;
    claimForm: FormGroup;
    endosoHasError: boolean;
    inputIdTipoEndoso: boolean;
    closeResult: string;
    activeSubmitFilterPolicy: boolean = false;
    IdRamo: boolean = false;
    templatePostEndoso: number = 1;
    resultPostEndosoMessage: string;
    detalleInteresAsegurado: any;
    permissionMenu: any;
    config: any;
    hasLoadindRD: boolean = false;

    private subscriptions: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/
    public claimHasError$: Observable<any>;
    public claimHasErrorSubject = new Subject<any>();
    public requiredDocument$: Observable<ClaimsDocuments[]>;
    public requiredDocumentSubject = new Subject<ClaimsDocuments[]>();


    constructor(
        public insuranceService: InsuranceService,
        public claimsService: ClaimsService,
        public listClaimsService: ListClaimsService,
        public documentService: DocumentService,
        public interestService: InterestService,
        private layout: LayoutService,
        private auth: AuthService,
        private fb: FormBuilder,
        private modalService: NgbModal,
        private modalLoading: NgbModal,
        public sanitizer: DomSanitizer,
        public helperServices: HelperServices,
        private modalRequiredDocumentos: NgbModal,
    ) {}

    // angular lifecircle hooks
    async ngOnInit() {
        this.config = JSON.parse(localStorage.getItem("remote_params"));
        
        this.initForm();

        this.extrasUserDropdownStyle = this.layout.getProp(
            'extras.user.dropdown.style'
        );
        this.user$ = this.auth.currentUserSubject.asObservable();
        this.user$.subscribe(user=> {
            this._user = user;
        });

        this.listClaimsService.fetch();
        this.paginator = this.listClaimsService.paginator;

        this.pais = this.helperServices.getPais();
        this.estado = this.helperServices.getEstado();
        this.ciudad = this.helperServices.getCiudad();
        this.codigopostal = this.helperServices.getCodigoPostal();
        

        this.ramos = this.insuranceService.getRamos();
        this.meses = this.insuranceService.getMeses();
        this.anyos = this.insuranceService.getAnyos();
        this.companies = this.helperServices.getCompaniaSeguros();
        this.requiredDocument$ = this.requiredDocumentSubject.asObservable();
        this.requiredDocument$.subscribe((x) => {
            if(x) {
                this.hasLoadindRD = true;
            }
        });
		this.initForm();

        const sb1 = this.listClaimsService.isLoading$.subscribe(res => this.isLoading = res);

        this.subscriptions.push(sb1);
        this.permissionMenu = JSON.parse(localStorage.getItem("permissionMenu"))[0];

        this.claimHasError$ = this.claimHasErrorSubject.asObservable();
    }

    ngOnDestroy() {
        this.subscriptions.forEach((sb) => sb.unsubscribe());
        this.claimHasErrorSubject.unsubscribe();
    }

    async clickView(id = 0, _templateView) {
        var g = this;
        switch ((this.templateView = _templateView)) {
            case 1:
                this.IdReclamo = null;
                this.templateView = _templateView;
                break;
            case 2:
                this.IdReclamo = id;
                this.claim_selected = this.listClaimsService.extracData(this.IdReclamo, this.listClaimsService.items$);
                //(document.getElementById("textTipoInteres") as HTMLElement).innerHTML = event.target.options[event.target.selectedIndex].text;
                this.editClaims();
                break;
        }
    }

    d(text) {

    }


    async clickDownloadDocument(content, id, filename, event) {
    //event.currentTarget.disabled = true;
    this.modalLoading.open(content, this.loadingModalConfig);

    var base64String = await this.documentService.get_documents_by(Array(`IdDocumento=${id}`).join('&')).then( (base64String) => {
        const linkSource = `data:application/pdf;base64,${base64String}`;
        const downloadLink = document.createElement("a");
    
        downloadLink.href = linkSource;
        downloadLink.download = filename;
        downloadLink.click();
    }).finally(() => {
        this.modalLoading.dismissAll();
    });

    }

    changeFilterMode(event) {
        this.insuredFilter = event.target.value;
    }

    changeRamo(event) {
        this.subramos = this.insuranceService.getSubRamos("IdRamo=" + event.target.value).finally(() => {
            this.IdRamo = event.target.value > 0 ? event.target.value : false;
        });
    }

    changeTipoInteres(event) {
        if(event.target.value) {
            this.causareclamo = this.claimsService.getCausaReclamo(Array(`IdPoliza=${this.claim_selected.IdPoliza}`, `IdTipoInteres=${event.target.value}`).join('&'));
            (document.getElementById("textTipoInteres") as HTMLElement).innerHTML = event.target.options[event.target.selectedIndex].text;
        }
    }

    initForm() {

    this.filterPolicyForm = this.fb.group({
        inputIdReclamo: [''],
        inputIdPoliza: [''],
        inputMes: [''],
        inputAnyo: [''],
        inputRamo: [''],
        inputSubRamo: [''],
        inputNroDePoliza: [''],
        inputNroReclamo: [''],
        inputAsegurado: [''],
        inputPlaca: [''],
        inputIdentificacion: [''],
        inputIdCompania: [''],
        inputGrupoEconomico: ['']
    });

    this.claimForm = this.fb.group({
        inputIdReclamo: ['', Validators.compose([])],
        inputIdPoliza: [''],
        inputNroReclamo: [''],
        inputFecha: ['', Validators.compose([Validators.required])],
        inputFechaOcurrencia: ['', Validators.compose([Validators.required])],
        inputNroPoliza: ['', Validators.compose([Validators.required])],
        inputEmail: ['', Validators.compose([Validators.required])],
        inputTelefono: ['', Validators.compose([Validators.required])],
        inputQuerella: ['', Validators.compose([Validators.required])],
        inputIdPais: [''],
        inputIdEstado: [''],
        inputIdCiudad: [''],
        inputIdTipoInteres: [{value:'', disabled:true}, Validators.compose([Validators.required])],
        inputIdCausa: [{value:'', disabled:true}, Validators.compose([Validators.required])],
        inputReportadoPor: ['', Validators.compose([Validators.required])],
        inputIdEsAsegurado: [{value:'', disabled:true}],
        inputIdEnUso: [{value:'', disabled:true}, Validators.compose([Validators.required])],
        inputIdParentesco: [{value:'', disabled:true}, Validators.compose([Validators.required])],
        inputNombreCompletoPolicia: [''],
        inputIdCodigoPostal: [''],
        inputCodigoPostalII: [''],
        inputDescripcion: ['', Validators.compose([Validators.required])],
        inputUnidadAsegurada: [''],
        inputUbicacionReclamo: ['', Validators.compose([Validators.required])]
    });

    this.interestForm = this.fb.group({
        insured_filter_mode : [
        1,
        Validators.compose([
            Validators.minLength(3),
            Validators.maxLength(320), // https://stackoverflow.com/questions/386294/what-is-the-maximum-length-of-a-valid-email-address
        ]),
        ],
        insured_filter_mode_1: [
        '',
        Validators.compose([
            Validators.minLength(1),
            Validators.maxLength(100),
        ]),
        ],
        insured_filter_mode_2: [
        '',
        Validators.compose([
            Validators.minLength(1),
            Validators.maxLength(100),
        ]),
        ],
        insured_filter_mode_3: [
        '',
        Validators.compose([
            Validators.minLength(1),
            Validators.maxLength(100),
        ]),
        ],
    });
    }

    editClaims() {
        var fecha1 = {
            year: parseInt(_moment(this.claim_selected.Fecha).format('yyyy'), 10),
            month: parseInt(_moment(this.claim_selected.Fecha).format('MM'), 10),
            day: parseInt(_moment(this.claim_selected.Fecha).format('DD'), 10)
        };

        var fecha2 = {
            year: parseInt(_moment(this.claim_selected.FechaOcurrencia).format('yyyy'), 10),
            month: parseInt(_moment(this.claim_selected.FechaOcurrencia).format('MM'), 10),
            day: parseInt(_moment(this.claim_selected.FechaOcurrencia).format('DD'), 10)
        };

        this.parentesco = this.helperServices.getParentesco();
        this.tipointeres = this.claimsService.getTipoInteres(Array(`IdPoliza=${this.claim_selected.IdPoliza}`).join('&'));
        this.causareclamo = this.claimsService.getCausaReclamo(Array(`IdPoliza=${this.claim_selected.IdPoliza}`, `IdTipoInteres=${this.claim_selected.IdTipoInteres}`).join('&'));
        this.sino = this.helperServices.getSiNo();

        this.claimForm.patchValue({
            "inputIdReclamo" : this.claim_selected.IdReclamo,
            "inputIdPoliza" : this.claim_selected.IdPoliza,
            "inputNroPoliza" : this.claim_selected.NroDePoliza,
            "inputNroReclamo" : this.claim_selected.NroReclamo,
            "inputEmail" : this.claim_selected.Email,
            "inputFecha" : fecha1,
            "inputFechaOcurrencia" : fecha2,
            "inputTelefono" : this.claim_selected.Telefono,
            "inputQuerella": this.claim_selected.Querella,
            "inputIdTipoInteres" : this.claim_selected.IdTipoInteres,
            "inputIdCausa" : this.claim_selected.IdCausa,
            "inputReportadoPor" : this.claim_selected.ReportadoPor,
            "inputIdEsAsegurado" : this.claim_selected.IdEsAsegurado,
            "inputIdEnUso" : this.claim_selected.IdEnUso,
            "inputIdParentesco" : this.claim_selected.IdParentesco,
            "inputNombreCompletoPolicia" : this.claim_selected.NombreCompletoPolicia,
            "inputDescripcion": this.claim_selected.Descripcion,
            "inputUbicacionReclamo": this.claim_selected.UbicacionReclamo
        });
    }

    submitClaim(content) {
        var g = this;
        
        this.claimHasErrorSubject.next(false);

        if(this.claimForm.valid) {
            this.modalLoading.open(content, this.loadingModalConfig);
            
            var date1 = "";
            if( typeof(this.claimForm.value.inputFecha) == 'object' && this.claimForm.value.inputFecha != null) {
                if(this.claimForm.value.inputFecha.year){
                    let date1 = Array(this.claimForm.value.inputFecha.year, this.claimForm.value.inputFecha.month,this.claimForm.value.inputFecha.day).join('/')
                }
            }

            var params = {
                "IdReclamo": this.claim_selected.IdReclamo,
                "IdPoliza": this.claim_selected.IdPoliza,
                "Fecha": date1,
                "NroPoliza": this.claim_selected.NroDePoliza,
                "Email": this.claimForm.value.inputEmail,
                "Telefono": this.claimForm.value.inputTelefono,
                "Querella": this.claimForm.value.inputQuerella,
                "IdPais": this.claimForm.value.inputIdPais,
                "IdEstado": this.claimForm.value.inputIdEstado,
                "IdCiudad": this.claimForm.value.inputIdCiudad,
                "IdCodigoPostal": this.claimForm.value.inputIdCodigoPostal,
                "CodigoPostalII": this.claimForm.value.inputCodigoPostalII,
                "Descripcion": this.claimForm.value.inputDescripcion,
                "UnidadAsegurada": this.claimForm.value.inputUnidadAsegurada,
                "UbicacionReclamo": this.claimForm.value.inputUbicacionReclamo
            };

            this.claimsService.postCrearReclamo((params)).then(response => {

                if(_.size(response[0])) {
                    this.IdReclamo = response[0].IdReclamo;
                }
                else {
                    this.claimHasErrorSubject.next(true);
                }

            }).finally(()=> {
				g.modalLoading.dismissAll();
			}).catch((reason: any)=>{
                this.claimHasErrorSubject.next(true);
            });
        }
        else {

        }
    }
    

    submitFilterPolicy(content) {
        //this.modalLoading.open(content, this.loadingModalConfig);
    
        var paramsGet = Array( 
            `IdEntidad=${this._user.id}`,
            `Asegurado=${this.filterPolicyForm.value.inputAsegurado || ''}`,
            `IdRamo=${this.filterPolicyForm.value.inputRamo || ''}`,
            `IdSubRamo=${this.filterPolicyForm.value.inputSubRamo || ''}`,
            `IdMes=${this.filterPolicyForm.value.inputMes || ''}`,
            `IdAno=${this.filterPolicyForm.value.inputAnyo || ''}`,
            `NroReclamo=${this.filterPolicyForm.value.inputNroReclamo|| ''}`,
            `NroDePoliza=${this.filterPolicyForm.value.inputNroDePoliza || ''}`,
            `Identificacion=${this.filterPolicyForm.value.inputIdentificacion || ''}`,
            `Placa=${this.filterPolicyForm.value.inputPlaca || ''}`
        )

        if(this.permissionMenu.VerGrupoEconomico == 1) {
            paramsGet.push(`GrupoEconomico=${this.filterPolicyForm.value.inputGrupoEconomico || ''}`);
        }

        if(this.permissionMenu.VerCompania == 1) {
            paramsGet.push(`IdCompania=${this.filterPolicyForm.value.inputIdCompania || ''}`);
        }

        this.listClaimsService.patchState({ paramsGet : paramsGet.join('&') });
    } 

    clickDownloadEstatement(content, IdPoliza) {
        this.modalLoading.open(content, this.loadingModalConfig);
        this.documentService.getPolicyEstatement("IdPoliza="+IdPoliza).then((res) => {
    
        this.helperServices.printPreview(res[0].Documento, res[0].NombreDocumento, "application/pdf");
    
        }).finally(() => {
            this.modalLoading.dismissAll();
        });
    }

    onclickModalUploadRequiredDocument(content) {
        this.hasLoadindRD = true;

        this.modalRequiredDocumentos.open(content, this.loadingModalConfig);

        this.claimsService.getDocumentosReclamo(`IdReclamo=${this.IdReclamo}`).then( (response:ClaimsDocuments[]) => {
            if(response) {
                this.requiredDocumentSubject.next(response);
            }

        }).finally(() => {
            this.hasLoadindRD = false;
        });
    }

    onViewDocument(content, IdTipoDocumento) {
        this.claimsService.getDescargarDocumentosReclamo(`IdReclamo=${this.IdReclamo}&IdTipoDocumento=${IdTipoDocumento}`).then(response => {
           if(typeof(response[0].Documento) != "undefined") {
            const linkSource = `data:application/pdf;base64,${response[0].Documento}`;
            const downloadLink = document.createElement("a");
        
            downloadLink.href = linkSource;
            downloadLink.download = response[0].NameDoc;
            //downloadLink.click();

            new JsFileDownloader({ 
                url:  `data:application/pdf;base64,${response[0].Documento}`,
                contentType: false
              });


            //this.helperServices.printPreview3(response[0].Documento, response[0].NameDoc);
            }
            else {
                alert("No se pudo descarga el documento.")
            }
            }).finally(()=> {
          
        });
    }

    onclickUploadRequiredDocument(content, IdTipoDocumento) {
        if( ! (document.getElementById(`file${IdTipoDocumento}`) as HTMLInputElement).files[0] ) {
            alert("Debe seleccionar un documento para poder subirlo");
        }
        else {
            this.requiredDocumentSubject.next(null);
            this.hasLoadindRD = true;

            var params = {
                "IdReclamo" : this.claimForm.value.inputIdReclamo,
                "IdTipoDocumento" : IdTipoDocumento,
                "file" : `file${IdTipoDocumento}`
            };

            this.claimsService.postCargarDocumentoReclamo(params).then(response => {
                this.hasLoadindRD = false;

                if(response) {
                    this.getDocumentosReclamo(this.IdReclamo);
                }
                else {
                    alert(response[0].Error);
                }
                
            }).finally(() => {
                this.hasLoadindRD = false;
            })
        }
    }

    getDocumentosReclamo(IdReclamo) {
        this.claimsService.getDocumentosReclamo(`IdReclamo=${this.IdReclamo}`).then( (response:ClaimsDocuments[]) => {
            if(response) {
                this.requiredDocumentSubject.next(response);
            }
        }).finally(() => {
            this.hasLoadindRD = false;
        });
    }

    preUpload(event, IdTipoDocumento) {
        let file = event.target.files[0];
        if (event.target.files.length > 0){
            (document.getElementById(`custom-file-label-${IdTipoDocumento}`) as HTMLInputElement).innerText = file.name;
        }
    }

    // pagination
    paginate(paginator: PaginatorState) {
    this.claimsService.patchState({ paginator });
    }

    onclickModalInteresAsegurado(content, item, id) {
    this.loadingModal= true;

    this.modalService.open(content,  {size: 'lg'} ).result.then((result) => {
        console.log(result)
    }, (reason) => { // this.getDismissReason(reason)
        
    });

    console.log(this.detalleInteresAsegurado = item);
    this.loadingModal = false;
    /*
    this.interestService.extracData(id, this.interestService.items$).finally(() => {
        this.loadingModal = false;
    });    
    */
    }
}
    